export default "__VITE_ASSET__65e21315__"